import React from "react";
import clsx from "clsx";

import { Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

import unauthorizedImage from "../../img/restricted_area.png";

const useUnauthorizedClasses = makeStyles(() => ({
  container: {
    paddingTop: 150,
    paddingLeft: 0,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  paragraph: {
    width: 500,
    margin: 20,
  },
}));

const Unauthorized: React.FC<{ message: string }> = ({ message }) => {
  const classes = useUnauthorizedClasses();

  return (
    <div className={clsx(classes.container)}>
      <img
        className="mb-4"
        alt="Unauthorized"
        src={unauthorizedImage}
        height={201}
        width={273}
      />
      <Typography component="h1" gutterBottom variant="h3">
        You do not have permission to perform this action
      </Typography>
      <Typography component="p" className={classes.paragraph}>
        {message}
      </Typography>
      <Button color="primary" variant="contained" href="/settings/team">
        View Admins
      </Button>
    </div>
  );
};

export default Unauthorized;
